import { c as _c } from "react/compiler-runtime";
import PersonRemoveAlt1Icon from "@mui/icons-material/PersonRemoveAlt1";
import React, { useContext } from "react";
import CancelEvent from "@/app/(main)/(club)/mes-clubs/[id]/components/cancel-event";
import EditEvent from "@/app/(main)/(club)/mes-clubs/[id]/components/edit-event";
import EditEventModalContent from "@/app/(main)/(club)/mes-clubs/[id]/components/edit-event-modal-content";
import EditEventModalContentMember from "@/app/(main)/(club)/mes-clubs/[id]/components/edit-event-modal-content-member";
import { ModalEventView } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal-event-view";
import RestoreEvent from "@/app/(main)/(club)/mes-clubs/[id]/components/restore-event";
import ComponentLoading from "@/components/global/component-loading";
import Icon from "@/components/icon";
import { sidebarContext } from "@/context/sidebar-context";
import { useModalStore } from "@/stores/modal-store";
import { Club, EventForCalendar, EventRead, SidebarContextProps } from "@/TS/Interfaces/global_interfaces";
import { EventTypeText } from "@/TS/KeyMappings/global_key_mappings";
import { IconType } from "@/TS/Types/global_types";
interface PictoAction {
  picto: IconType;
  fun(setVal: SidebarContextProps["setVal"], setIsHide: SidebarContextProps["setIsHide"], event: EventRead, arrOfEvents: EventForCalendar[] | undefined, editable: boolean, handleMonthDate: Function, isPresident: boolean, handleFetch: () => Promise<void>, ...rest: unknown[]): boolean | undefined;
  conditionToDisplay(event: EventRead, editable: boolean, isPresident: boolean): boolean;
}
const pictoArr: PictoAction[] = [{
  picto: "eye-show",
  fun: (setVal, setIsHide, event, arrOfEvents, editable, handleMonthDate, isPresident, handleFetch, isPublic: boolean, club: Club | undefined) => {
    useModalStore.getState().open({
      component: <ModalEventView type={event.type} clubSlug={event.clubSlug} startDate={event.startDate} isPublic={isPublic} publicClub={club} />,
      modalOptions: {
        loader: {
          component: <ComponentLoading />
        }
      }
    });
    return true;
  },
  conditionToDisplay: (_event, _editable, _isPresident) => {
    return true;
  }
}, {
  picto: "meeting-modif",
  fun: (setVal, setIsHide, event, arrOfEvents, editable, handleMonthDate, isPresident, handleFetch, setShouldRefresh: ((value: boolean) => void) | undefined) => {
    const eventDate = new Date(event.startDate!);
    const currentDate = new Date();

    // If the event is in the past, we display EditEventModalContent (modal to edit ODJ and add absent members)
    if (eventDate < currentDate && isPresident) {
      useModalStore.getState().open({
        component: <EditEventModalContent eventProps={event} />,
        modalOptions: {
          closeOnOverlayClick: false,
          loader: {
            component: <ComponentLoading />
          }
        }
      });
    } else {
      // If the event is in the future
      if (isPresident) {
        // if the user is president, we display EditEvent (modal to edit a futur event)
        setVal(<EditEvent event={event} arrOfEvents={arrOfEvents} handleMonthDate={handleMonthDate} />);
        return true;
      } else {
        // if the user is not president, we display EditEventModalContentMember (modal to declare himself absent)
        useModalStore.getState().open({
          component: <EditEventModalContentMember eventProps={event} handleFetch={handleFetch} setShouldRefresh={setShouldRefresh} />,
          modalOptions: {
            closeOnOverlayClick: false,
            loader: {
              component: <ComponentLoading />
            },
            size: {
              width: "w-[50rem]"
            }
          }
        });
      }
    }
  },
  conditionToDisplay: (event, editable, isPresident) => {
    // If the event is in the past, we don't display the button if the user is not president
    if (event.startDate! < new Date().toISOString() && !isPresident) {
      return false;
    }
    return editable;
  }
}, {
  picto: "meeting-cancel",
  fun: (setVal, setIsHide, event, arrOfEvents, editable, handleMonthDate, isPresident) => {
    if (!isPresident) {
      return false;
    }
    setVal(<CancelEvent event={event} />);
    return true;
  },
  conditionToDisplay: (event, editable, _isPresident) => {
    return !event.cancel && editable;
  }
}];
function EventCard(t0) {
  const $ = _c(59);
  const {
    event,
    arrOfEvents,
    editable: t1,
    handleMonthDate,
    colorFormat,
    textColor,
    isPresident: t2,
    handleFetch,
    setShouldRefresh,
    isPublic: t3,
    club
  } = t0;
  const editable = t1 === undefined ? false : t1;
  const isPresident = t2 === undefined ? false : t2;
  const isPublic = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== event.startDate) {
    const eventDate = new Date(event.startDate);
    t4 = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate(), 23, 59, 59);
    $[0] = event.startDate;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const eventEndOfDay = t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = new Date();
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const isPastEvent = eventEndOfDay < t5;
  const {
    setVal,
    setIsHide
  } = useContext(sidebarContext);
  const getTimeStartEnd = _temp;
  const prettyDate = _temp2;
  const t6 = `bg-white p-4 flex-col font-bold relative text-center w-full flex ${event.cancel ? "opacity-60 rounded-t-lg" : "rounded-lg"}`;
  let t7;
  if ($[3] !== arrOfEvents || $[4] !== club || $[5] !== editable || $[6] !== event || $[7] !== handleFetch || $[8] !== handleMonthDate || $[9] !== isPastEvent || $[10] !== isPresident || $[11] !== isPublic || $[12] !== setIsHide || $[13] !== setShouldRefresh || $[14] !== setVal) {
    t7 = pictoArr.map(t8 => {
      const {
        picto,
        fun,
        conditionToDisplay
      } = t8;
      if (!conditionToDisplay(event, editable, isPresident)) {
        return;
      }
      if (picto === "meeting-cancel" && (isPastEvent || !isPresident)) {
        return;
      }
      return <div key={picto} className="flex items-center justify-center p-1 hover:bg-hover-grey hover:rounded-full">{picto === "meeting-modif" && !isPresident && !isPastEvent ? <PersonRemoveAlt1Icon onClick={() => fun(setVal, setIsHide, event, arrOfEvents, editable, handleMonthDate, isPresident, handleFetch, setShouldRefresh, isPublic, club) ?? undefined} className="!fill-dark-grey cursor-pointer" style={{
          fontSize: 17
        }} /> : <Icon onClick={() => fun(setVal, setIsHide, event, arrOfEvents, editable, handleMonthDate, isPresident, handleFetch, isPublic, club) ?? undefined} className="!fill-dark-grey cursor-pointer" size={picto === "meeting-modif" || picto === "meeting-cancel" ? 17 : 25} icon={picto} />}</div>;
    });
    $[3] = arrOfEvents;
    $[4] = club;
    $[5] = editable;
    $[6] = event;
    $[7] = handleFetch;
    $[8] = handleMonthDate;
    $[9] = isPastEvent;
    $[10] = isPresident;
    $[11] = isPublic;
    $[12] = setIsHide;
    $[13] = setShouldRefresh;
    $[14] = setVal;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="flex gap-3 mb-2 md:absolute md:right-4">{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isPastEvent) {
    t9 = isPastEvent ? {
      color: "lightgray"
    } : undefined;
    $[18] = isPastEvent;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `${textColor} flex flex-col`;
  let t11;
  if ($[20] !== event.startDate) {
    t11 = prettyDate(event.startDate);
    $[20] = event.startDate;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t9) {
    t12 = <div style={t9} className={t10}>{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isPastEvent) {
    t13 = isPastEvent ? {
      backgroundColor: "lightgray"
    } : undefined;
    $[26] = isPastEvent;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = `${colorFormat} absolute -left-6 h-3.5 inline-block aspect-square rounded-full`;
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <label style={t13} className={t14} />;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== event.type) {
    t16 = EventTypeText.get(event.type);
    $[31] = event.type;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t15 || $[34] !== t16) {
    t17 = <p className="flex relative items-center self-end text-sm gap-3">{t15}{" "}{t16}</p>;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== event) {
    t18 = getTimeStartEnd(event);
    $[36] = event;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18) {
    t19 = <div className="flex flex-col self-end">{t17}{t18}</div>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t12 || $[42] !== t19) {
    t20 = <div className="flex  gap-12">{t12}{t19}</div>;
    $[41] = t12;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t20 || $[45] !== t6 || $[46] !== t8) {
    t21 = <div className={t6}>{t8}{t20}</div>;
    $[44] = t20;
    $[45] = t6;
    $[46] = t8;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== event.absent) {
    t22 = event.absent && <div className="bg-event bg-opacity-30 text-left py-2 px-4 text-sm rounded-b-lg"><p className="font-bold">Absent(e)</p></div>;
    $[48] = event.absent;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== event || $[51] !== isPastEvent || $[52] !== isPresident || $[53] !== setVal) {
    t23 = event.cancel && isPresident && !isPastEvent && <div className="bg-event bg-opacity-30 text-left py-2 px-4 text-sm rounded-b-lg"><p className="font-bold">Réunion annulée</p><button className="underline font-normal" onClick={() => setVal(<RestoreEvent e={event} />)}>Cliquez ici pour la réactiver</button></div>;
    $[50] = event;
    $[51] = isPastEvent;
    $[52] = isPresident;
    $[53] = setVal;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t21 || $[56] !== t22 || $[57] !== t23) {
    t24 = <><div>{t21}{t22}{t23}</div></>;
    $[55] = t21;
    $[56] = t22;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  return t24;
}
function _temp2(date) {
  const newDate = new Date(date);
  const prettyWeek = newDate.toLocaleDateString(undefined, {
    weekday: "long"
  });
  const prettyDay = newDate.toLocaleDateString(undefined, {
    day: "numeric"
  });
  const prettyMonth = newDate.toLocaleDateString(undefined, {
    month: "short"
  });
  const prettyYear = newDate.toLocaleDateString(undefined, {
    year: "numeric"
  });
  return <div className="self-start"><p>{prettyWeek}</p><p className="text-2xl font-bold">{prettyDay}</p><p>{prettyMonth} {prettyYear}</p></div>;
}
function _temp(t0) {
  const {
    startDate,
    endDate
  } = t0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const prettyStartHour = start.toLocaleDateString(undefined, {
    hour: "2-digit",
    minute: "2-digit"
  });
  const prettyEndHour = end.toLocaleDateString(undefined, {
    hour: "2-digit",
    minute: "2-digit"
  });
  if (prettyStartHour.includes("\xE0") && prettyEndHour.includes("\xE0")) {
    return <p className="text-sm font-normal text-left">{prettyStartHour.split("\xE0")[1]} - {prettyEndHour.split("\xE0")[1]}</p>;
  }
  return <p className="text-sm font-normal text-left">{prettyStartHour.split(" ")[1]} - {prettyEndHour.split(" ")[1]}</p>;
}
export default EventCard;